import UserFormContent, {
  EditUserFormPayload,
  UserFormContentProps,
} from "../UserForm";

import { UserType } from "@/types/user/userType";

type EditUserFormProps = {
  user: UserType;
  options: UserFormContentProps["options"];
  isEditingSelf?: boolean;
  isSubmitting: boolean;
  onSubmitForm: (payload: EditUserFormPayload) => void;
  onSuccess?: () => void;
};

const EditUserForm: React.FC<EditUserFormProps> = ({
  user,
  options,
  isEditingSelf,
  isSubmitting,
  onSubmitForm,
  onSuccess,
}) => {
  const handleSubmit = (payload: EditUserFormPayload) => {
    onSubmitForm(payload);
  };

  return (
    <UserFormContent
      type="edit"
      user={user}
      options={options}
      isRoleDisabled={isEditingSelf}
      isSubmitting={isSubmitting}
      onSubmitForm={handleSubmit}
      onSuccess={onSuccess}
    />
  );
};

export default EditUserForm;
